// extracted by mini-css-extract-plugin
export default {"topic":"topic_topic__15wkN","trending_negative":"topic_trending_negative__8oAH8","trending_positive":"topic_trending_positive__yrtUN"};